import { render } from "./Stepper.vue?vue&type=template&id=22b9dc8c"
import script from "./Stepper.vue?vue&type=script&lang=js"
export * from "./Stepper.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__